export const routes = {
  modellingTool: "/modelling-tool",
  assessmentsMU: "/assessments-mu",
  assessmentsMC: "/assessments-mc",
  assignments: "/assignments",
  impressum: "/impressum",
};
